import { Component, Inject, OnInit, OnDestroy } from '@angular/core'
import { FormBuilder, FormGroup, Validators } from '@angular/forms'
import { faSave } from '@fortawesome/free-solid-svg-icons'
import { ServiceOrderService } from '../service-order.service'
import { BaseComponentComponent } from 'src/app/shared/base-component/base-component.component'
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog'
import { ServiceOrder } from '../service-order'
import { CustomerModel } from '../../customer/customer'
import { VehicleModel } from '../../vehicle/vehicle'
import { EquipmentModel } from '../../equipment/equipment/equipment'
import { TechnicianModel } from '../../technician/technician'
import { CustomerService } from '../../customer/customer.service'
import { VehicleService } from '../../vehicle/vehicle.service'
import { TechnicianService } from '../../technician/technician.service'
import { EquipmentService } from '../../equipment/equipment/equipment.service'
import { CepService } from 'src/app/shared/utils/handleCep.service'
import { catchError, takeUntil, Subject } from 'rxjs'
import { MatBottomSheet } from '@angular/material/bottom-sheet'
import { SucessBottomSheetComponent } from '../../helpers/sucess-bottom-sheet/sucess-bottom-sheet.component'
import { ErrorBottomSheet } from '../../helpers'
import { ChipService } from '../../equipment/chip/chip.service'
import { ChipModel } from '../../equipment/chip/chip'
import { DateAdapter } from '@angular/material/core';
import { CustomDateAdapter } from 'src/app/shared/utils/CustomDateAdapter'
import { AccountTypeService } from 'src/app/core/services/account-type.service'

@Component({
  selector: 'app-create-service-order',
  templateUrl: './create-service-order.component.html',
  styleUrls: ['./create-service-order.component.scss'],
  providers: [
    { provide: DateAdapter, useClass: CustomDateAdapter },
  ]
})
export class CreateServiceOrderComponent extends BaseComponentComponent implements OnInit, OnDestroy {

  isEdit: boolean = false;
  OrderToEdit: ServiceOrder | null = null

  faSaveFile = faSave

  createServiceOrder: FormGroup
  serviceInformations: FormGroup
  technicianForm: FormGroup
  customerForm: FormGroup

  customerList: Array<CustomerModel>
  filteredCustomerOptions: any

  equipmentList: Array<EquipmentModel>
  filteredEquipmentOptions: any

  vehiclesList: Array<VehicleModel>
  filteredVehicleOptions: any

  technicianList: Array<TechnicianModel>
  filteredTechnicianOptions: any

  chipList: Array<ChipModel>
  filteredChipOptions: any

  techSelected: TechnicianModel | '' = ''
  vehicleSelected: VehicleModel | '' = ''
  customerSelected: CustomerModel | '' = ''
  equipmentSelected: EquipmentModel | '' = ''
  chipSelected: ChipModel | '' = ''
  dateTimeScheduled: Date | string = ''
  ErrorStep: string
  value: number = 0
  minDate: Date = new Date();
  currentISOTime = this.minDate.toISOString().slice(0, -8)

  stepToControlRegister: number = 0
  unsubscribe$: Subject<void> = new Subject()
  isAssociacaoAccount: boolean = false
  
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ServiceOrder,
    private _bottomSheet: MatBottomSheet,
    private dialog: MatDialog,
    private _formBuilder: FormBuilder,
    private cepService: CepService,
    private _customerService: CustomerService,
    private _vehicleService: VehicleService,
    private _technicianService: TechnicianService,
    private _equipmentService: EquipmentService,
    private _chipService: ChipService,
    private dialogRef: MatDialogRef<CreateServiceOrderComponent>,
    private _serviceOrderService: ServiceOrderService,
    private accountTypeService: AccountTypeService
  ) {
    super()
    // Verificar tipo de conta
    this.isAssociacaoAccount = this.accountTypeService.isAssociacao()
    this.createFormsBuilder()

    if (data) {
      this.isEdit = true
      this.OrderToEdit = data
    }


  }

  createFormsBuilder(): void {

    this.createServiceOrder = this._formBuilder.group({
      title: ['', Validators.required],
      deadline: ['', Validators.required],
      tipoOrdem: ['PADRÃO', Validators.required]
    })

    this.technicianForm = this._formBuilder.group({
      technician: ['', Validators.required],
      price: [0, Validators.required]
    })

    this.serviceInformations = this._formBuilder.group({
      serviceType: ['', Validators.required],
      obs: [''],
      vehicleModel: [''],
      licensePlate: [''],
      equipment: [''],
      chip: [''],

    })

    this.serviceInformations.controls['vehicleModel'].disable()

    this.customerForm = this._formBuilder.group({
      customerName: ['', Validators.required],
      dateTime: ['', Validators.required],
      cep: ['', Validators.required],
      address: ['', Validators.required],
      addressNumber: ['', Validators.required],
      neighbourAddress: ['', Validators.required],
      city: ['', Validators.required],
      state: ['', Validators.required],
      complementAddress: ['']//useless
    })

    this.customerForm.get('customerName')!.valueChanges.subscribe(search => {
      this.filterItens('customer', search)
    })

    this.serviceInformations.get('chip')!.valueChanges.subscribe(search => {
      this.filterItens('chip', search)
    })

    this.serviceInformations.get('licensePlate')!.valueChanges.subscribe(search => {
      this.filterItens('vehicle', search)
    })

    this.serviceInformations.get('equipment')!.valueChanges.subscribe(search => {
      this.filterItens('equipment', search)
    })

    this.technicianForm.get('technician')!.valueChanges.subscribe(search => {
      this.filterItens('technician', search)
    })

    // Para contas não-ASSOCIAÇÃO, campo de equipamento deve estar habilitado (seleção manual)
    // Para contas ASSOCIAÇÃO, será desabilitado apenas quando preenchido automaticamente do veículo
    if (!this.isAssociacaoAccount) {
      this.serviceInformations.controls['equipment'].enable()
    } else {
      this.serviceInformations.controls['equipment'].disable()
    }
    
    // Atualizar validação quando o tipo de ordem mudar (apenas para contas ASSOCIAÇÃO)
    if (this.isAssociacaoAccount) {
      this.createServiceOrder.get('tipoOrdem')!.valueChanges.subscribe(tipoOrdem => {
        const requiresVehicleEquipmentChip = tipoOrdem === 'PADRÃO'
        
        if (requiresVehicleEquipmentChip) {
          this.serviceInformations.controls['licensePlate'].setValidators([Validators.required])
          this.serviceInformations.controls['equipment'].setValidators([Validators.required])
          this.serviceInformations.controls['chip'].setValidators([Validators.required])
          this.serviceInformations.controls['vehicleModel'].setValidators([Validators.required])
          // Campo de equipamento desabilitado para contas ASSOCIAÇÃO (preenchido automaticamente do veículo)
          this.serviceInformations.controls['equipment'].disable()
        } else {
          // Tipo ASSOCIAÇÃO - não requer veículo, equipamento e chip
          this.serviceInformations.controls['licensePlate'].clearValidators()
          this.serviceInformations.controls['equipment'].clearValidators()
          this.serviceInformations.controls['chip'].clearValidators()
          this.serviceInformations.controls['vehicleModel'].clearValidators()
          // Limpar valores quando não são mais necessários
          this.serviceInformations.controls['licensePlate'].setValue('')
          this.serviceInformations.controls['equipment'].setValue('')
          this.serviceInformations.controls['chip'].setValue('')
          this.serviceInformations.controls['vehicleModel'].setValue('')
          this.vehicleSelected = ''
          this.equipmentSelected = ''
          this.chipSelected = ''
          // Manter campo desabilitado quando tipo é ASSOCIAÇÃO
          this.serviceInformations.controls['equipment'].disable()
        }
        this.serviceInformations.controls['licensePlate'].updateValueAndValidity()
        this.serviceInformations.controls['equipment'].updateValueAndValidity()
        this.serviceInformations.controls['chip'].updateValueAndValidity()
        this.serviceInformations.controls['vehicleModel'].updateValueAndValidity()
      })
    } else {
      // Para contas não-ASSOCIAÇÃO, sempre requerer veículo, equipamento e chip (tipo sempre PADRÃO)
      this.serviceInformations.controls['licensePlate'].setValidators([Validators.required])
      this.serviceInformations.controls['equipment'].setValidators([Validators.required])
      this.serviceInformations.controls['chip'].setValidators([Validators.required])
      this.serviceInformations.controls['vehicleModel'].setValidators([Validators.required])
      // Campo de equipamento habilitado para contas não-ASSOCIAÇÃO (seleção manual)
      this.serviceInformations.controls['equipment'].enable()
    }

  }

  filterItens(type: string, search: any) {
    if (!type || !search) return;

    // Convert search to string if it's an object
    const searchStr = typeof search === 'string' ? search : (search?.nome || search?.imei || search?.numero_linha || search?.placa || '');

    if (!searchStr) return;

    switch (type) {
      case 'customer':
        if (!this.customerList) return;
        this.filteredCustomerOptions = this.customerList.filter(
          (data) => {
            return data.nome && data.nome
              .toLowerCase()
              .indexOf(searchStr.toLowerCase()) > -1;
          });
        break;

      case 'equipment':
        if (!this.equipmentList) return;
        this.filteredEquipmentOptions = this.equipmentList.filter(
          (data) => {
            return data.imei && data.imei
              .toLowerCase()
              .indexOf(searchStr.toLowerCase()) > -1;
          });
        break;

      case 'chip':
        if (!this.chipList) return;
        this.filteredChipOptions = this.chipList.filter(
          (data) => {
            return data.numero_linha && data.numero_linha
              .toLowerCase()
              .indexOf(searchStr.toLowerCase()) > -1;
          });
        break;

      case 'vehicle':
        if (!this.vehiclesList) return;
        this.filteredVehicleOptions = this.vehiclesList.filter(
          (data) => {
            return data.placa && data.placa
              .toLowerCase()
              .indexOf(searchStr.toLowerCase()) > -1;
          });
        break;

      case 'technician':
        if (!this.technicianList) return;
        this.filteredTechnicianOptions = this.technicianList.filter(
          (data) => {
            return data.nome && data.nome
              .toLowerCase()
              .indexOf(searchStr.toLowerCase()) > -1;
          });
        break;
    }
  }

  filterTechnician(id: number): TechnicianModel | '' {
    let tecnico = this.technicianList
      .filter(tech => tech.id === id)

    return tecnico[0] || ''
  }

  filterVehicle(placa: string): VehicleModel | '' {
    let vehicle = this.vehiclesList
      .filter(car => car.placa === placa)

    if (vehicle[0]) {
      this.serviceInformations.controls['vehicleModel'].setValue(String(vehicle[0].modelo))
    }
    return vehicle[0] || ''
  }

  filterChip(id: string): ChipModel | '' {
    let chip = this.chipList
      .filter(c => Number(c.id) === Number(id))

    return chip[0] || ''
  }

  filterEquipment(id: string): EquipmentModel | '' {
    let equipment = this.equipmentList
      .filter(equip => equip.imei === id)

    return equipment[0] || ''
  }


  filterCustomer(customerId: number): CustomerModel | '' {
    let customer = this.customerList
      .filter(cus => Number(cus.id) === customerId)

    return customer[0] || ''
  }

  serviceTypeFilter(type: string): string {
    let typeId: string = ''

    switch (type) {
      case 'Instalação':
        typeId = '0'
        break
      case 'Manutenção':
        typeId = '1'
        break
      case 'Retirada':
        typeId = '2'
        break
    }
    return typeId
  }

  get requiresVehicleEquipmentChip(): boolean {
    // Se for conta não-ASSOCIAÇÃO, sempre mostrar campos (tipo sempre PADRÃO)
    if (!this.isAssociacaoAccount) {
      return true
    }
    // Para contas ASSOCIAÇÃO, verificar tipo de ordem selecionado
    const tipoOrdem = this.createServiceOrder?.controls['tipoOrdem']?.value
    // Tipo PADRÃO requer veículo, equipamento e chip
    // Tipo ASSOCIAÇÃO não requer
    return tipoOrdem === 'PADRÃO'
  }

  setDatetimeLocal(datetime: string) {
    const dt = new Date(datetime);
    return dt.toISOString().slice(0, 16);
  }

  editFormsBuilder(os: ServiceOrder) {

    this.createServiceOrder.controls['title'].setValue(os.nome)
    this.createServiceOrder.controls['deadline'].setValue(new Date(os.prazo_instalacao))
    // Para contas não-ASSOCIAÇÃO, sempre usar PADRÃO (campo não aparece)
    // Para contas ASSOCIAÇÃO, usar o valor da OS ou padrão
    const tipoOrdemValue = this.isAssociacaoAccount ? (os.tipoOrdem || 'ASSOCIAÇÃO') : 'PADRÃO'
    this.createServiceOrder.controls['tipoOrdem'].setValue(tipoOrdemValue)
    // Desabilitar alteração do tipo na edição
    this.createServiceOrder.controls['tipoOrdem'].disable()

    this.serviceInformations.controls['serviceType'].setValue(this.serviceTypeFilter(os.serviceType))
    this.serviceInformations.controls['obs'].setValue(os.descricao)
    
    // Campos opcionais - preencher baseado no tipo de ordem
    // Para contas não-ASSOCIAÇÃO, sempre preencher (tipo sempre PADRÃO)
    // Para contas ASSOCIAÇÃO, só preencher se tipo for PADRÃO
    const tipoOrdem = os.tipoOrdem || 'PADRÃO'
    const shouldFill = !this.isAssociacaoAccount || tipoOrdem === 'PADRÃO'
    
    if (shouldFill && os.veiculo) {
      this.serviceInformations.controls['licensePlate'].setValue(os.veiculo)
      this.serviceInformations.controls['vehicleModel'].setValue(os.veiculo.modelo)
    }

    this.customerForm.controls['dateTime'].setValue(this.setDatetimeLocal(os.data_agendamento))
    this.customerForm.controls['address'].setValue(os.endereco)
    this.customerForm.controls['addressNumber'].setValue(os.endereco_num)
    this.customerForm.controls['neighbourAddress'].setValue(os.bairro)
    this.customerForm.controls['city'].setValue(os.cidade)
    this.customerForm.controls['state'].setValue(os.estado)
    this.customerForm.controls['cep'].setValue(os.cep)

    this.technicianForm.controls['price'].setValue(Number(os.valor))

  }

  ngOnInit(): void {
    // Para contas não-ASSOCIAÇÃO, campo de equipamento deve estar habilitado (seleção manual)
    // Para contas ASSOCIAÇÃO, será desabilitado quando preenchido automaticamente do veículo
    if (!this.isAssociacaoAccount) {
      this.serviceInformations.controls['equipment'].enable()
    } else {
      this.serviceInformations.controls['equipment'].disable()
    }

    // Para contas não-ASSOCIAÇÃO, sempre usar tipo PADRÃO (campo não aparece)
    if (!this.isAssociacaoAccount) {
      this.createServiceOrder.controls['tipoOrdem'].setValue('PADRÃO')
      // Não desabilitar, mas o campo não aparece no HTML
    }

    this.fetchData()
    if (this.OrderToEdit) {
      this.editFormsBuilder(this.OrderToEdit)
      // Aplicar validação inicial baseada no tipo de conta e tipo de ordem
      if (!this.isAssociacaoAccount) {
        // Para contas não-ASSOCIAÇÃO, sempre requerer veículo, equipamento e chip (tipo sempre PADRÃO)
        this.serviceInformations.controls['licensePlate'].setValidators([Validators.required])
        this.serviceInformations.controls['equipment'].setValidators([Validators.required])
        this.serviceInformations.controls['chip'].setValidators([Validators.required])
        this.serviceInformations.controls['vehicleModel'].setValidators([Validators.required])
        // Para contas não-ASSOCIAÇÃO, sempre habilitar campo de equipamento (seleção manual)
        this.serviceInformations.controls['equipment'].enable()
      } else {
        // Para contas ASSOCIAÇÃO, verificar tipo de ordem selecionado
        const tipoOrdem = this.createServiceOrder.controls['tipoOrdem'].value || 'ASSOCIAÇÃO'
        const requiresVehicleEquipmentChip = tipoOrdem === 'PADRÃO'
        
        if (requiresVehicleEquipmentChip) {
          this.serviceInformations.controls['licensePlate'].setValidators([Validators.required])
          this.serviceInformations.controls['equipment'].setValidators([Validators.required])
          this.serviceInformations.controls['chip'].setValidators([Validators.required])
          this.serviceInformations.controls['vehicleModel'].setValidators([Validators.required])
          // Para contas ASSOCIAÇÃO, campo de equipamento desabilitado (preenchido automaticamente)
          this.serviceInformations.controls['equipment'].disable()
        } else {
          // Tipo ASSOCIAÇÃO - não requer veículo, equipamento e chip
          this.serviceInformations.controls['licensePlate'].clearValidators()
          this.serviceInformations.controls['equipment'].clearValidators()
          this.serviceInformations.controls['chip'].clearValidators()
          this.serviceInformations.controls['vehicleModel'].clearValidators()
          // Manter campo desabilitado quando tipo é ASSOCIAÇÃO
          this.serviceInformations.controls['equipment'].disable()
        }
      }
      this.serviceInformations.controls['licensePlate'].updateValueAndValidity()
      this.serviceInformations.controls['equipment'].updateValueAndValidity()
      this.serviceInformations.controls['chip'].updateValueAndValidity()
      this.serviceInformations.controls['vehicleModel'].updateValueAndValidity()
    }

  }

  fetchData() {
    this.getCustomers()
    this.getTechnicianList()
    // Carregar veículos, equipamentos e chips sempre (podem ser necessários se tipo for PADRÃO)
    this.getVehiclesList()
    this.getEquipment()
    this.getChip()
  }

  getCustomers(): void {
    this._customerService.getAllCustomersNoPaginate().subscribe((data) => {
      this.customerList = data
      this.filteredCustomerOptions = data

      if (this.isEdit) {
        this.customerSelected = this.filterCustomer(this.data.cliente_id)
        this.customerForm.controls['customerName'].setValue(this.customerSelected)
      }
    })
  }

  getVehiclesList() {
    this._vehicleService.getFullListVehicles().subscribe((data) => {
      this.vehiclesList = data
      this.filteredVehicleOptions = data

      if (this.isEdit && this.data.veiculo) {
        // Para contas não-ASSOCIAÇÃO, sempre preencher (tipo sempre PADRÃO)
        // Para contas ASSOCIAÇÃO, só preencher se tipo de ordem for PADRÃO
        const tipoOrdem = this.createServiceOrder?.controls['tipoOrdem']?.value || 'PADRÃO'
        const shouldFill = !this.isAssociacaoAccount || tipoOrdem === 'PADRÃO'
        
        if (shouldFill) {
          this.vehicleSelected = this.data.veiculo
          this.serviceInformations.controls['licensePlate'].setValue(this.vehicleSelected)
          // Se veículo tiver rastreador vinculado, preencher automaticamente APENAS para contas ASSOCIAÇÃO
          if (this.isAssociacaoAccount && this.data.veiculo.equipment_id) {
            // O equipamento será preenchido no getEquipment()
            // Mas também podemos chamar onVehicleSelected para garantir consistência
            setTimeout(() => {
              this.onVehicleSelected(this.data.veiculo)
            }, 100)
          }
        }
      }
    })
  }

  getTechnicianList() {
    this._technicianService.getFullTechniciansList().subscribe((data) => {
      this.technicianList = data
      this.filteredTechnicianOptions = data

      if (this.isEdit) {
        this.techSelected = this.filterTechnician(this.data.instalador_id)
        this.technicianForm.controls['technician'].setValue(this.techSelected)
      }
    })
  }

  getEquipment() {
    // Buscar todos os equipamentos (não apenas livres) para permitir seleção na edição
    this._equipmentService.getFullListEquipment(false).subscribe((data) => {
      const list = Array.isArray(data) ? data : (data?.results || [])
      this.equipmentList = list.filter((e: EquipmentModel) => e.status === 0)
      this.filteredEquipmentOptions = this.equipmentList

      if (this.isEdit) {
        // Para contas não-ASSOCIAÇÃO, sempre preencher (tipo sempre PADRÃO)
        // Para contas ASSOCIAÇÃO, só preencher se tipo de ordem for PADRÃO
        const tipoOrdem = this.createServiceOrder?.controls['tipoOrdem']?.value || 'PADRÃO'
        const shouldFill = !this.isAssociacaoAccount || tipoOrdem === 'PADRÃO'
        
        if (shouldFill) {
          if (this.data.equipamento_id) {
            // Se já tem equipamento_id direto na OS, preencher (independente do tipo de conta)
            this.equipmentSelected = this.filterEquipment(this.data.equipamento_id)
            this.serviceInformations.controls['equipment'].setValue(this.equipmentSelected)
          } else if (this.isAssociacaoAccount && this.data.veiculo && this.data.veiculo.equipment_id) {
            // Se na edição o veículo tiver rastreador vinculado, mostrar ele APENAS para contas ASSOCIAÇÃO
            const equipment = this.equipmentList.find(e => e.imei === this.data.veiculo.equipment_id)
            if (equipment) {
              this.equipmentSelected = equipment
              this.serviceInformations.controls['equipment'].setValue(equipment)
            } else {
              // Buscar o equipamento se não estiver na lista
              this._equipmentService.getFullListEquipment(false)
                .pipe(takeUntil(this.unsubscribe$))
                .subscribe({
                  next: (res: any) => {
                    const fullList = Array.isArray(res) ? res : (res?.results || [])
                    const equipment = fullList.find((e: EquipmentModel) => e.imei === this.data.veiculo.equipment_id)
                    if (equipment) {
                      this.equipmentSelected = equipment
                      this.serviceInformations.controls['equipment'].setValue(equipment)
                      this.equipmentList.push(equipment)
                      this.filteredEquipmentOptions.push(equipment)
                    }
                  }
                })
            }
          }
        }
      }
    })
  }

  getChip() {
    this._chipService.getFullListChip().subscribe((data) => {
      this.chipList = data
      this.filteredChipOptions = data

      if (this.isEdit && this.data.chip && this.data.chip.id) {
        // Para contas não-ASSOCIAÇÃO, sempre preencher (tipo sempre PADRÃO)
        // Para contas ASSOCIAÇÃO, só preencher se tipo de ordem for PADRÃO
        const tipoOrdem = this.createServiceOrder?.controls['tipoOrdem']?.value || 'PADRÃO'
        const shouldFill = !this.isAssociacaoAccount || tipoOrdem === 'PADRÃO'
        
        if (shouldFill) {
          this.chipSelected = this.filterChip(this.data.chip.id)
          this.serviceInformations.controls['chip'].setValue(this.chipSelected)
        }
      }
    })
  }

  onVehicleSelected(vehicle: any) {
    const vehicleSelected = vehicle
    this.vehicleSelected = vehicleSelected

    this.serviceInformations.controls['vehicleModel']
      .setValue(vehicleSelected.modelo)
    
    // Preencher rastreador automaticamente do veículo vinculado APENAS para contas ASSOCIAÇÃO
    if (this.isAssociacaoAccount && vehicleSelected.equipment_id) {
      // Buscar o equipamento na lista
      const equipment = this.equipmentList.find(e => e.imei === vehicleSelected.equipment_id)
      if (equipment) {
        this.equipmentSelected = equipment
        this.serviceInformations.controls['equipment'].setValue(equipment)
        // Limpar erro se existir
        this.serviceInformations.controls['equipment'].setErrors(null)
      } else {
        // Se não estiver na lista, buscar
        this._equipmentService.getFullListEquipment(false)
          .pipe(takeUntil(this.unsubscribe$))
          .subscribe({
            next: (res: any) => {
              const list = Array.isArray(res) ? res : (res?.results || [])
              const equipment = list.find((e: EquipmentModel) => e.imei === vehicleSelected.equipment_id)
              if (equipment) {
                this.equipmentSelected = equipment
                this.serviceInformations.controls['equipment'].setValue(equipment)
                // Adicionar à lista se não estiver
                if (!this.equipmentList.find(e => e.imei === equipment.imei)) {
                  this.equipmentList.push(equipment)
                  this.filteredEquipmentOptions.push(equipment)
                }
                // Limpar erro se existir
                this.serviceInformations.controls['equipment'].setErrors(null)
              }
            }
          })
      }
    } else if (this.isAssociacaoAccount && !vehicleSelected.equipment_id) {
      // Se for conta ASSOCIAÇÃO e veículo não tem rastreador vinculado, limpar seleção
      this.equipmentSelected = ''
      this.serviceInformations.controls['equipment'].setValue('')
      const tipoOrdem = this.createServiceOrder?.controls['tipoOrdem']?.value
      if (tipoOrdem === 'PADRÃO') {
        // Se tipo PADRÃO, mostrar erro (obrigatório)
        this.serviceInformations.controls['equipment'].setErrors({
          'noEquipment': 'Este veículo não possui rastreador vinculado. Por favor, vincule um rastreador ao veículo antes de criar a OS.'
        })
      } else {
        // Se tipo ASSOCIAÇÃO, apenas limpar (não é obrigatório)
        this.serviceInformations.controls['equipment'].setErrors(null)
      }
    }
    // Para contas não-ASSOCIAÇÃO, não preencher automaticamente - usuário deve selecionar manualmente
  }

  onCustomerSelected(event: any) {
    const customer = event.option.value
    const enderecoNumero: number = customer.endereco_num
    const form = this.customerForm

    form.controls['cep'].setValue(customer.cep)
    this.handleSearchCep()

    enderecoNumero &&
      form.controls['addressNumber'].setValue(enderecoNumero)
  }

  handleSearchCep() {
    this.cepService.searchByCep(this.customerForm)
  }

  displayCustomer(data: any): string {
    return data ? data.nome : ''
  }

  displayVehicle(data: any): string {
    return data ? data.placa : ''
  }

  displayChip(data: any): string {
    return data ? data.numero_linha : ''
  }

  displayTechnician(tech: any): string {
    return tech ? tech.nome : ''
  }

  displayEquipment(equipment: EquipmentModel) {
    return equipment ? equipment.modelo + ' | ' + equipment.imei : ''
  }



  handleCloseModal() {
    this.dialogRef.close();
  }

  serviceOrderBuilder(): any {

    const customer = this.customerForm.controls['customerName'].value
    const technician = this.technicianForm.controls['technician'].value
    // Se o campo estiver desabilitado, usar getRawValue() para obter o valor
    // Usar equipmentSelected diretamente se o campo estiver desabilitado
    const equipment = this.serviceInformations.controls['equipment'].disabled 
      ? this.equipmentSelected
      : this.serviceInformations.controls['equipment'].value
    const vehicle = this.serviceInformations.controls['licensePlate'].value
    const chip = this.serviceInformations.controls['chip'].value
    // Se estiver desabilitado (edição), usar o valor atual, senão pegar do form
    const tipoOrdemControl = this.createServiceOrder.controls['tipoOrdem']
    const tipoOrdem = tipoOrdemControl.disabled ? tipoOrdemControl.value : tipoOrdemControl.value

    let order: any = {
      //createForm
      nome: this.createServiceOrder.controls['title'].value,
      prazo_instalacao: this.createServiceOrder.controls['deadline'].value,
      tipo_ordem: tipoOrdem,

      //technicianForm
      valor: this.technicianForm.controls['price'].value,
      instalador_id: technician.id,

      //serviceForm
      tipo_servico: this.serviceInformations.controls['serviceType'].value,
      descricao: this.serviceInformations.controls['obs'].value,

      //customerForm
      cliente_id: customer.id,
      data_agendamento: this.customerForm.controls['dateTime'].value,
      cep: this.customerForm.controls['cep'].value,
      endereco: this.customerForm.controls['address'].value,
      endereco_num: this.customerForm.controls['addressNumber'].value,
      bairro: this.customerForm.controls['neighbourAddress'].value,
      cidade: this.customerForm.controls['city'].value,
      estado: this.customerForm.controls['state'].value,
    }

    // Campos opcionais - adicionar baseado no tipo de ordem
    // Para contas não-ASSOCIAÇÃO, sempre adicionar (tipo sempre PADRÃO)
    // Para contas ASSOCIAÇÃO, só adicionar se tipo de ordem for PADRÃO
    const shouldAddVehicleEquipmentChip = !this.isAssociacaoAccount || tipoOrdem === 'PADRÃO'
    
    if (shouldAddVehicleEquipmentChip) {
      if (vehicle && vehicle.id) {
        order.veiculo_id = vehicle.id
      }
      if (equipment && equipment.imei) {
        order.equipment_id = equipment.imei
      }
      if (chip && chip.id) {
        order.chip_id = chip.id
      }
    } else {
      // Tipo ASSOCIAÇÃO em conta ASSOCIAÇÃO - garantir que campos sejam null
      order.veiculo_id = null
      order.equipment_id = null
      order.chip_id = null
    }

    if (this.isEdit) {
      let editOrder = {
        id: this.OrderToEdit!.id,
        ...order
      }

      order = editOrder
    }

    return order
  }


  handleSaveBtn() {
    this.ErrorStep = ''

    // Validar campos condicionais baseado no tipo de ordem
    const tipoOrdem = this.createServiceOrder.controls['tipoOrdem'].value
    const requiresVehicleEquipmentChip = tipoOrdem === 'PADRÃO'

    if (requiresVehicleEquipmentChip) {
      // Para tipo PADRÃO, tornar obrigatórios
      this.serviceInformations.controls['licensePlate'].setValidators([Validators.required])
      this.serviceInformations.controls['equipment'].setValidators([Validators.required])
      this.serviceInformations.controls['chip'].setValidators([Validators.required])
      this.serviceInformations.controls['vehicleModel'].setValidators([Validators.required])
    } else {
      // Para tipo ASSOCIAÇÃO, tornar opcionais
      this.serviceInformations.controls['licensePlate'].clearValidators()
      this.serviceInformations.controls['equipment'].clearValidators()
      this.serviceInformations.controls['chip'].clearValidators()
      this.serviceInformations.controls['vehicleModel'].clearValidators()
    }
    this.serviceInformations.controls['licensePlate'].updateValueAndValidity()
    this.serviceInformations.controls['equipment'].updateValueAndValidity()
    this.serviceInformations.controls['chip'].updateValueAndValidity()
    this.serviceInformations.controls['vehicleModel'].updateValueAndValidity()

    if (this.createServiceOrder.valid &&
      this.technicianForm.valid &&
      this.serviceInformations.valid &&
      this.customerForm.valid) {

      const newOrder = this.serviceOrderBuilder()

      const req = !this.isEdit ?
        this._serviceOrderService.createOrder(newOrder) :
        this._serviceOrderService.editOrder(newOrder)


      req.pipe(
        catchError((err: any) => {
          throw 'Erro: ' + err
        }),

      )
        .subscribe(
          {
            next: () => {
              this._serviceOrderService.clearCacheServ()
              this.dialog.closeAll()
              this._bottomSheet.open(SucessBottomSheetComponent,
                {
                  data: !this.isEdit ? 'Ordem de serviço criada!' : 'Ordem de serviço alterada!'
                })
            },
            error: (errorData: any) => {
              this._serviceOrderService.clearCacheServ()
              this.dialog.closeAll()
              this._bottomSheet.open(ErrorBottomSheet,
                {
                  data:
                  {
                    redirectTo: 'ordem-servico',
                    error: errorData
                  }
                })
            }
          }
        )
    } else {

      if (!this.createServiceOrder.valid) {
        this.createServiceOrder.markAllAsTouched()
        this.ErrorStep = '1: OS'

      } else if (!this.technicianForm.valid) {
        this.technicianForm.markAllAsTouched()
        this.ErrorStep = '2: Cliente'

      } else if (!this.serviceInformations.valid) {
        this.serviceInformations.markAllAsTouched()
        this.ErrorStep = '3: Serviço'

      } else if (!this.customerForm.valid) {
        this.customerForm.markAllAsTouched()
        this.ErrorStep = '4: Técnico'
      }
    }
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next()
    this.unsubscribe$.complete()
  }

}
